export const SET_TOKEN = 'SET_TOKEN';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_ORG_ID = 'SET_ORG_ID';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const SET_USER_DOMAIN = 'SET_USER_DOMAIN';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_LOG_OUT_URL = 'SET_LOG_OUT_URL';
export const SET_ACTIVE_MEMBERPROGRAM_ID = 'SET_ACTIVE_MEMBERPROGRAM_ID';
